import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Registreren", -1)
const _hoisted_2 = { class: "content-box" }
const _hoisted_3 = { class: "content-box" }
const _hoisted_4 = { class: "content-box" }
const _hoisted_5 = { class: "content-box" }

import {ref} from "vue";
	import {useRouter} from 'vue-router';
	import {FetchToken} from "../utils/FetchData";
	import emitter from '../main';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'RegisterPage',
  setup(__props) {

	const name = ref('');
	const email = ref('');
	const password = ref('');
	const confirm = ref('');
	const router = useRouter();

	const errorEmail = ref('');
	const errorPassword = ref('');

	async function register() {
		const body = new URLSearchParams({
			name: name.value,
			email: email.value,
			password: password.value,
			password_confirmation: confirm.value
		});

		errorEmail.value = '';
		errorPassword.value = '';

		const data = await FetchToken('register', body, true);
		if(!data.isError) {
			sessionStorage.setItem('token', data.access_token);
			sessionStorage.setItem('player', JSON.stringify(data.player));
			emitter.emit('authorized');
			router.replace('/');
			return;
		}

		if(data.errors != undefined) {
			if(data.errors.email != undefined)
				errorEmail.value = data.errors.email[0];
			if(data.errors.password != undefined)
				errorPassword.value = data.errors.password[0];
		}
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "Naam",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event))
      }, null, 512), [
        [_vModelText, name.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        placeholder: "Email",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((email).value = $event))
      }, null, 512), [
        [_vModelText, email.value]
      ])
    ]),
    _createElementVNode("p", {
      class: _normalizeClass(["error no-margin", {hidden: errorEmail.value.length == 0}])
    }, _toDisplayString(errorEmail.value), 3),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("input", {
        type: "password",
        placeholder: "Wachtwoord",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event))
      }, null, 512), [
        [_vModelText, password.value]
      ])
    ]),
    _createElementVNode("p", {
      class: _normalizeClass(["error no-margin", {hidden: errorPassword.value.length == 0}])
    }, _toDisplayString(errorPassword.value), 3),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives(_createElementVNode("input", {
        type: "password",
        placeholder: "Wachtwoord herhalen",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((confirm).value = $event))
      }, null, 512), [
        [_vModelText, confirm.value]
      ])
    ]),
    _createElementVNode("button", {
      class: "content-box",
      onClick: register
    }, " Registreren ")
  ], 64))
}
}

})